const frontHairStyles = [
  'ぱっつん',
  '右分け',
  '真ん中分け',
  '左分け',
  'デコだし',
  'メカクレ',
  '片目隠れ',
  '右流れ',
  '左流れ',
  '後れ毛',
  '外ハネ',
  '内ハネ',
  '揃え',
  '真ん中束',
]

const sideHairStyles = [
  '耳掛け',
  '耳隠れ',
  '耳ちょっと出',
  'ちょろ毛',
  'シャギー',
  '三つ編み',
  'ウェーブ',
]

const rearHairStyles = [
  'ショート',
  'ボブ',
  'セミロング',
  'ロング',
  '外ハネ',
  '内巻き',
  'サイドポニー',
  'ポニー',
  'ツインテール',
  'ツーサイド',
  'おさげ',
  'ハーフアップ',
  'ウェーブ',
  '三つ編み',
]

const eyeTypes = [
  '普通の目',
  'タレ目',
  '細目',
  'つり目',
  'ジト目',
  '困り目',
  '三白眼',
]

const featuresA = [
  '無し',
  '編み込み',
  'アホ毛',
  'メッシュ',
  '外ハネ',
  'お団子',
  '髪飾り',
  '癖っ毛',
]

const featuresB = [
  '無し',
  'ほくろ',
  'メガネ',
  'ふとまゆ',
  '八重歯',
  'ギザ歯',
]

const ages = [
  'ロリ',
  '普通',
  'お姉さん',
]

const bustSizes = [
  'AA',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
]

const bodyTypes = [
  '細身',
  '普通',
  'ぽっちゃり',
]

export {
  frontHairStyles,
  sideHairStyles,
  rearHairStyles,
  eyeTypes,
  ages,
  featuresA,
  featuresB,
  bustSizes,
  bodyTypes,
}
